import type { PlanRouteGroupV3 } from "./types";

interface FindRouteGroupByRouteIdArgs {
  routeGroups: PlanRouteGroupV3[];
  routeId: string;
}

export const findRouteGroupByRouteId = ({
  routeGroups,
  routeId,
}: FindRouteGroupByRouteIdArgs): PlanRouteGroupV3 | null => {
  for (const routeGroup of routeGroups) {
    if (routeGroup.routes.some((route) => route.id === routeId)) {
      return routeGroup;
    }
  }
  return null;
};
